import React from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { FaPlay, FaStop } from "react-icons/fa";
import { liveEventApi } from './api';
import { PortalizedModalContext } from "./../../../components/PortalizedModal";
import { renderRailsErrors } from "../../../utils/rails_error_parser";

export default function StatusUpdateButton({ liveEvent }) {
  const queryClient = useQueryClient();
  const confirmModal = React.useContext( PortalizedModalContext );

  const updateStatus = useMutation(liveEventApi.update ,
    {
      onSuccess: (values) => {
        toast.success(`Event ${values.title} is ${values.status}.`);
        const liveEvents = queryClient.getQueryData(['live-events-list', values.offer_id]);
        const updatedEventindex = liveEvents.findIndex((e) => e.id === liveEvent.id);

        if(liveEvents[updatedEventindex]){
           liveEvents[updatedEventindex] = values;
         }

        queryClient.setQueryData(['live-events-list', values.offer_id], liveEvents);
      },
      onError: (error) => {
        renderRailsErrors(error);
      },
    }
  )

  if(liveEvent.status === 'upcoming'){
    return(
      <button
        className="btn btn-sm p-0 ps-2 action-item cursor-pointer"
        title='Start Event'
        onClick={ () => {
          confirmModal.setModalContent(
            null,
            <div>
              <div className="px-3">
                <p>Are you sure you want to start event?</p>
              </div>
              <div className="p-3 text-right">
                <button
                  className="btn btn-dark rounded-0 px-3"
                  onClick={() => {
                    updateStatus.mutate({ id: liveEvent.id, attrs: { status: 'live'} })
                    confirmModal.closeModal();
                  }}
                >
                  Yes, start event.
                </button>
              </div>
            </div>
          )
          confirmModal.openModal()
        }}
      >
        <FaPlay className='fs-14 color-black'/>
      </button>
    )
  }

  if(liveEvent.status === 'live') {
    return (
      <button
        className="btn btn-sm p-0 ps-2 action-item cursor-pointer"
        title='Complete Event'
        onClick={ () => {
          confirmModal.setModalContent(
            null,
            <div>
              <div className="px-3">
                <p>Are you sure you want to mark event `completed`?</p>
              </div>
              <div className="p-3 text-right">
                <button
                  className="btn btn-dark rounded-0 px-3"
                  onClick={() => {
                    updateStatus.mutate({ id: liveEvent.id, attrs: { status: 'completed'} })
                    confirmModal.closeModal();
                  }}
                >
                  Yes, mark completed.
                </button>
              </div>
            </div>
          )
          confirmModal.openModal()
        }}
      >
        <FaStop className='fs-14 color-black'/>
      </button>
    )
  }

  return <></>;
}